import React, {useEffect, useState} from "react";
import Dialog from '@material-ui/core/Dialog';
import t from '../../../helpers/t';
import {useSelector, boxTrackingActions} from "inbooma-api";
import {Biscuit} from "../../../../utils";
import { moment } from "../../../../../vendor";
import Paginator from "../../../components/paginator";

const ShowTrackingsDialog = ({handleCloseDialog, dispatch, facility,showTrackingType}) => {
    const language = Biscuit.get('user.lang').replace('-', '_');
    const _boxTrackings = useSelector(state => state.box_trackings_data.boxTrackings);
    const [paginationLimit, setPaginationLimit] = useState(20);
    const [pagination,setPagination] = useState({
        has_next_page: false,
        current_page: 1
    });
    const [initialized,setInitialized] = useState(false);
    const [boxTrackingsPending,setBoxTrackingsPending] = useState(false);

    useEffect(() => {
        if(facility !== null && showTrackingType !== null) {
            if(showTrackingType === 'facility') {
                dispatch(boxTrackingActions.getBoxTrackings({
                    token: Biscuit.get('token'),
                    filter: {
                        facility_id: facility.id,
                        direction: 'desc',
                        sort: 'created',
                        limit: paginationLimit,
                        page: 1
                    },
                    parameters: {
                        headers: {
                            'Accept-Language': language,
                            'Content-Language': language
                        }
                    }
                }));
            } else {
                dispatch(boxTrackingActions.getBoxTrackings({
                    token: Biscuit.get('token'),
                    filter: {
                        facility_slot_id: facility.id,
                        direction: 'desc',
                        sort: 'created',
                        limit: paginationLimit,
                        page: 1
                    },
                    parameters: {
                        headers: {
                            'Accept-Language': language,
                            'Content-Language': language
                        }
                    }
                }));
            }
            setBoxTrackingsPending(true);
            setInitialized(true);
        }
    },[]);

    useEffect(() => {
        if (_boxTrackings.success === "" || boxTrackingsPending === false) {
            return;
        }
        if (_boxTrackings.success === true){
            setPagination({..._boxTrackings.pagination});
        }
            setBoxTrackingsPending(false);
    },[_boxTrackings]);

    const loadNextPage = (page) => {

        if (!pagination.has_next_page) return;

        setBoxTrackingsPending(true);

        let requestFilter = {};
        requestFilter.sort = 'created';
        requestFilter.direction = 'desc';
        if(showTrackingType === 'facility') {
            requestFilter.facility_id = facility.id;
        }else {
            requestFilter.facility_slot_id = facility.id;
        }
        requestFilter.limit = paginationLimit;
        requestFilter.page = page;
        // fetch next page
        dispatch(boxTrackingActions.getBoxTrackings({
            token: Biscuit.get('token'),
            suffix: "",
            filter: requestFilter,
            parameters: {
                headers: {
                    'Accept-Language': language,
                    'Content-Language': language
                }
            }
        }));
    };

    const _showPopUp = (ev,name) => {
        let output = `
          <html>
            <head>
                <link href="https://fonts.googleapis.com/css?family=Open+Sans:400,600" rel="stylesheet">
                <title>` + t('info',null,'capital') + `</title>
                <style type="text/css">
                    body { font-family: "Open Sans",Helvetica,Arial,sans-serif; }
                    hode, html, table, thead { width: 100%; }
                    h4 { font-size: 18px; }
                    .printSpacer { height:100px; }
                </style>
                </head>
            <div>` + t(name+'_info') + `
            </body>
            </html>`;
        let rV = -1; // Return value assumes failure.

        if (navigator.appName == 'Microsoft Internet Explorer' || navigator.appName == 'Netscape') {

            var uA = navigator.userAgent;
            var rE = new RegExp("MSIE ([0-9]{1,}[\.0-9]{0,})");

            if (rE.exec(uA) != null) {
                rV = parseFloat(RegExp.$1);
            }
            else if (!!navigator.userAgent.match(/Trident.*rv\:11\./)) {
                rV = 11;
            }
        }

        const isChrome = /Chrome/.test(navigator.userAgent) && /Google Inc/.test(navigator.vendor);
        const newWindow = window.open('', '', 'height=700,width=674');

        newWindow.document.body.innerHTML = '';
        newWindow.document.body.innerHTML = output;
        if (rV >=10 || isChrome) {
            newWindow.focus(); // necessary for IE >= 10*
        } else {
            // e.g. Firefox
            setTimeout(() => {
                newWindow.opener.focus();
            }, 0);
        }
        return true;
    }


    return (
        <>
        {initialized &&
        <>
            <Dialog
                onClose={handleCloseDialog}
                aria-labelledby="changelogs-dialog-title"
                open={true}
                name="changeLogsDialog"
                id="multipleRecipientsDialog"
                maxWidth={"md"}
            >
                <header className="inb-multiple-recipients-header">

                    <button
                        onClick={handleCloseDialog}
                        type="button"
                        id="inb-multiple-recipients-dialog-close-button"
                        className="button hollow secondary right button-close-multiple-recipients-dialog round"
                        title={t("close box trackings")}
                    >
                        <i className="fi fi-x"></i>
                    </button>
                    <h4>{t('box trackings', null, 'capital')+ ' ' + (typeof facility.name !== 'undefined'?facility.name:'')}</h4>
                    {!boxTrackingsPending && typeof _boxTrackings.data !== 'undefined' && _boxTrackings?.data?.length > 0 &&
                        <div id="inb-c-main-header">
                            <ul className="inb-tabs row">
                                <li className="tabs-title column medium-3" style={{padding:0}}>{t('date')}</li>
                                <li className="tabs-title column medium-3" style={{paddingLeft:"7px"}}>{t('user')}</li>
                                <li className="tabs-title column medium-6">{t('description')}</li>
                            </ul>
                        </div>
                    }
                    {initialized && typeof _boxTrackings.data !== 'undefined' && _boxTrackings?.data?.length > 0 && !boxTrackingsPending && typeof pagination !== 'undefined' &&
                       <><br/><Paginator
                            pagination={pagination}
                            itemsCountPerPage={paginationLimit}
                            setPaginationLimit={setPaginationLimit}
                            pageRangeDisplayed={5}
                            onChange={loadNextPage}
                            mediumWidth={12}
                            upper={true}
                        /><br/></>}
                    {/* <label className="inb-form__controlLabel legendLabel"><a href="#"
                                                                        onClick={(e) => _showPopUp(e, 'voucher for temporary user')}><i
                className="inb-ico fi fi-info"> {t('info', null, 'capital')}</i></a></label>*/}

                </header>
                <div id="inb-c-main-multiple-recipients" className="inb-c-listing off-canvas-content"
                     data-off-canvas-content="">
                    {!boxTrackingsPending && typeof _boxTrackings.data !== 'undefined' && _boxTrackings?.data?.length > 0 ? _boxTrackings.data.map(boxTracking => {
                        return (<>
                            <div className="inb-c-item inb-c-item--recipient row" key={boxTracking.id}>
                                <div className="medium-3 small-12 column" title={t('id', null, 'capital')}
                                     style={{minWidth: '90px'}}>
                                    <span>{moment(boxTracking.created).format('DD.MM.YY HH:mm:ss')}</span>
                                </div>
                                <div className="medium-3 small-12 column username"
                                     title={t('recipient', null, 'capital')}
                                     style={{minWidth: '90px', cursor: 'pointer'}}>
                                    {boxTracking.user !== '' && !boxTracking.user.includes('('+t('deleted')+')')?<a href={`/users/${boxTracking.user_id}?path=/facilities`}><span>{boxTracking.user}</span></a>:<span>{t('unknown')}</span>}
                                </div>
                                <div className="medium-6 small-12 column description"
                                     title={t('profile', null, 'capital')} style={{minWidth: '90px'}}>
                                    <span>{boxTracking.description}</span>
                                </div>
                            </div>
                        </>)
                    }): <>
                    <div
                        id="inb-app-collection-empty"
                        className="inb-announcement">
                        <div className="inb-image-box">
                            <img src="assets/img/no_data.svg"/>
                        </div>
                        <h3>
                            { t('app_msg_collection_empty') }
                        </h3>
                        <p>
                            { t('app_msg_collection_empty_body') }
                        </p>
                    </div>
                </>}

                </div>

            </Dialog>
        </>
}
</>
    );
};

export default ShowTrackingsDialog;
